export var ZeroEtlIdentityColumnField;
(function (ZeroEtlIdentityColumnField) {
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_CLOUD_PROVIDER"] = "CLOUD_PROVIDER";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_CLOUD_ACCOUNT_ID"] = "CLOUD_ACCOUNT_ID";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_REGION"] = "REGION";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_RESOURCE_ID"] = "RESOURCE_ID";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_DATABASE"] = "DATABASE";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_SCHEMA"] = "SCHEMA";
    ZeroEtlIdentityColumnField["ZERO_ETL_IDENTITY_COLUMN_FIELD_TABLE"] = "TABLE";
})(ZeroEtlIdentityColumnField || (ZeroEtlIdentityColumnField = {}));
